import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";

import { Formik, Form, ErrorMessage } from "formik";
import axios from "axios";
import * as Yup from "yup";

import { makeStyles } from "@material-ui/core/styles";

import CircularProgress from "@material-ui/core/CircularProgress";
import { red } from "@material-ui/core/colors";
import SaveIcon from "@material-ui/icons/Save";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import Avatar from "@material-ui/core/Avatar";

import IconButton from "@material-ui/core/IconButton";
import PhotoCamera from "@material-ui/icons/PhotoCamera";

import Paper from "@material-ui/core/Paper";

import Divider from '@material-ui/core/Divider';

import { useSnackbar } from "notistack";

import ChipInput from "material-ui-chip-input";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  imageInput: {
    display: "none",
  },
  redText: {
    color: red[800],
  },
  button: {
   
    display: 'inline'
  }
}));

const VariantTypeSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  options: Yup.array().min(1).required("Options is required").typeError("Options must have at least 1 item"),
});

export default function VariantTypeEditForm({variantType, updateVariantType}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setLoading(false);
  };

  const handleChip = (chip) => {

  };

  const handleDeleteChip = (chip, index) => {};

  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    name: variantType !== undefined ? variantType.name : '',
    options: variantType !== undefined ? variantType.options.split(',') : [],
  }

  return (
    <React.Fragment>

<IconButton
        className={classes.button}
        startIcon={<EditIcon />}
        onClick={handleClickOpen}
      >
       <EditIcon fontSize="small" />
      </IconButton>

      <Formik
        initialValues={initialValues}
        validationSchema={VariantTypeSchema}
        onSubmit={(values, actions) => {
          setLoading(true);

           let formData = new FormData();
          formData.append('name', values.name);
          formData.append('options', values.options);
          formData.append("_method", "put");

          axios
            .post(`products/${variantType.product_id}/variant-types/${variantType.id}`, formData)
            .then((response) => {

              setLoading(false);
              actions.setSubmitting(false);
              actions.resetForm(true);
              setOpen(false);

              if (response.data && response.data.status) {
                enqueueSnackbar(`${response.data.message}`, {
                  variant: `${response.data.status}`,
                });
              }

              if (response.data && response.data.status === "success") {

                let variant_type = response.data.data;
                updateVariantType(variant_type);
                actions.setFieldValue('name', variant_type.name);
                actions.setFieldValue('options', variant_type.options.split(','));
              }
            })
            .catch(function (error) {


              setLoading(false);
              // actions.setErrors(error.response.data.errors);
              actions.setSubmitting(false);
            });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Update Variant Type
            </DialogTitle>

            <DialogContent dividers>
              <FormControl fullWidth>
                <TextField
                  id="name"
                  name="name"
                  label="Variant Name"
                  type="text"
                  value={values.name}
                  helperText={errors ? errors.name : ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors && errors.name && touched.name ? true : null}
                />
              </FormControl>

              <FormControl fullWidth>
                <ChipInput
                  id="options"
                  name="options"
                  label="Variant Options"
                  defaultValue={values.options}
                  onChange={(chips) => {
                    setFieldValue("options", chips);
                  }}
                  helperText={errors ? errors.options : ""}
                  onBlur={handleBlur}
                  error={
                    errors && errors.options && touched.options ? true : null
                  }
                />
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary" variant="outlined">
                Cancel
              </Button>

              <Button
                color="primary"
                variant="outlined"
                disabled={loading}
                onClick={handleSubmit}
                startIcon={
                  loading ? <CircularProgress size={16} /> : <EditIcon />
                }
              >
                {isSubmitting ? "Updating ..." : "Update"}
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Formik>
    </React.Fragment>
  );
}
